<template>
  <div class="app-container">
    <CrudTable entity="ProductGroup" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [{ field: 'code', width: '150px' }, 'description']
    };
  },
  methods: {
    generateSummary({ description }) {
      const summary = `${description}`;
      return summary;
    }
  }
};
</script>
